export const CargoDonut = () => {
  const segments = [
    { pct: 50, color: "#0e8c8c", label: "Proteins & growth factors", note: "signalling · VEGF · TGF-β" },
    { pct: 35, color: "#0a0a0a", label: "Nucleic acids", note: "mRNA & miRNA" },
    { pct: 15, color: "#9fd9d5", label: "Lipids & membrane", note: "protective bilayer" },
  ];
  const r = 105;
  const C = 2 * Math.PI * r;
  let offset = 0;
  return (
    <svg viewBox="0 0 400 470" className="w-full" role="img" aria-label="Typical exosome cargo composition donut chart" data-testid="diagram-cargo-donut">
      {[0, 1, 2].map((i) => {
        const seg = segments[i];
        const dash = (seg.pct / 100) * C;
        const el = (
          <circle
            key={i}
            cx="200" cy="180" r={r}
            fill="none" stroke={seg.color} strokeWidth="48"
            strokeDasharray={`${dash - 3} ${C - dash + 3}`}
            strokeDashoffset={-offset}
            transform="rotate(-90 200 180)"
          />
        );
        offset += dash;
        return el;
      })}
      <text x="200" y="172" textAnchor="middle" fill="#56636b" fontSize="13" letterSpacing="3">1,000+</text>
      <text x="200" y="194" textAnchor="middle" fill="#0a0a0a" fontSize="16" fontWeight="600">bio-active molecules</text>
      <text x="200" y="214" textAnchor="middle" fill="#56636b" fontSize="11">(illustrative)</text>
      {segments.map((s, i) => (
        <g key={`l${i}`} transform={`translate(30, ${340 + i * 46})`}>
          <rect width="14" height="14" fill={s.color} />
          <text x="26" y="12" fill="#0a0a0a" fontSize="14" fontWeight="600">{`${s.label} — ${s.pct}%`}</text>
          <text x="26" y="29" fill="#56636b" fontSize="11">{s.note}</text>
        </g>
      ))}
    </svg>
  );
};

const Panel = ({ x, children, label, sub }) => (
  <g transform={`translate(${x}, 0)`}>
    <rect x="0" y="30" width="200" height="170" rx="10" fill="#ffffff" stroke="#e4e9ec" />
    <text x="100" y="236" textAnchor="middle" fill="#0e8c8c" fontSize="12" fontWeight="600" letterSpacing="1.5">{label}</text>
    <text x="100" y="256" textAnchor="middle" fill="#56636b" fontSize="11">{sub}</text>
    {children}
  </g>
);

const Arrow = ({ x }) => (
  <g transform={`translate(${x}, 0)`}>
    <line x1="12" y1="115" x2="52" y2="115" stroke="#0e8c8c" strokeWidth="2" />
    <path d="M46 108 L58 115 L46 122" fill="none" stroke="#0e8c8c" strokeWidth="2" />
  </g>
);

export const BiogenesisFlow = () => (
  <svg viewBox="0 0 1000 280" className="w-full" role="img" aria-label="Exosome formation: biogenesis and release diagram" data-testid="diagram-biogenesis">
    <text x="1000" y="16" textAnchor="end" fill="#56636b" fontSize="11">applies to target cells in skin &amp; follicle research</text>
    <Panel x={0} label="01 · ENDOSOME FORMS" sub="cell membrane folds inward">
      <circle cx="100" cy="115" r="62" fill="#e3f2f0" stroke="#0e8c8c" strokeWidth="2" />
      <circle cx="100" cy="115" r="20" fill="#0e8c8c" opacity="0.25" />
      <circle cx="76" cy="92" r="7" fill="none" stroke="#0a0a0a" strokeWidth="1.5" />
      <circle cx="122" cy="132" r="7" fill="none" stroke="#0a0a0a" strokeWidth="1.5" />
    </Panel>
    <Arrow x={186} />
    <Panel x={252} label="02 · MULTIVESICULAR BODY" sub="vesicles bud inward">
      <circle cx="100" cy="115" r="62" fill="#e3f2f0" stroke="#0e8c8c" strokeWidth="2" />
      {[[78, 95], [116, 92], [73, 135], [120, 133], [100, 114]].map(([cx, cy], i) => (
        <circle key={i} cx={cx} cy={cy} r="10" fill="#ffffff" stroke="#0e8c8c" strokeWidth="1.5" />
      ))}
    </Panel>
    <Arrow x={438} />
    <Panel x={504} label="03 · FUSION & RELEASE" sub="vesicles exit the cell">
      <circle cx="100" cy="115" r="62" fill="#e3f2f0" stroke="#0e8c8c" strokeWidth="2" strokeDasharray="6 5" />
      <circle cx="142" cy="84" r="9" fill="#ffffff" stroke="#0e8c8c" strokeWidth="1.5" />
      <circle cx="156" cy="120" r="9" fill="#ffffff" stroke="#0e8c8c" strokeWidth="1.5" />
      <circle cx="141" cy="152" r="9" fill="#ffffff" stroke="#0e8c8c" strokeWidth="1.5" />
      <path d="M100 53 A62 62 0 0 1 162 115" fill="none" stroke="#0e8c8c" strokeWidth="3" />
    </Panel>
    <Arrow x={690} />
    <Panel x={756} label="04 · EXOSOMES" sub="30–150 nm messengers">
      <circle cx="56" cy="90" r="13" fill="#0e8c8c" opacity="0.9" />
      <circle cx="100" cy="130" r="13" fill="#0e8c8c" opacity="0.55" />
      <circle cx="50" cy="160" r="13" fill="#0a0a0a" opacity="0.85" />
      <circle cx="122" cy="86" r="8" fill="#9fd9d5" />
    </Panel>
  </svg>
);